import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // Set initial state
    this.dialogTarget.style.opacity = "0"
    this.dialogTarget.style.transform = "scale(0.95)"
    this.dialogTarget.style.transition = "opacity 0.2s ease-out, transform 0.2s ease-out"
  }

  open() {
    this.dialogTarget.showModal()

    // Trigger animation after modal is shown
    requestAnimationFrame(() => {
      this.dialogTarget.style.opacity = "1"
      this.dialogTarget.style.transform = "scale(1)"
    })
  }

  close() {
    // Animate out before closing
    this.dialogTarget.style.opacity = "0"
    this.dialogTarget.style.transform = "scale(0.95)"

    // Close after animation completes
    setTimeout(() => {
      this.dialogTarget.close()
    }, 200)
  }

  closeOnBackdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
} 